import logo from './logo.svg';
import './App.css';
import Maadhi from './maadhi'
function App() {
 
   return <Maadhi />;
 
}

export default App;
